export default "__VITE_ASSET__BOJrmK$y__"